"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInlineMarkup = void 0;
const react_1 = require("react");
// Matches either paired tags (strong/b/em/i/p) or self-closing br variants.
const INLINE_TAG_REGEX = /<(strong|b|em|i|p)>([\s\S]*?)<\/\1>|<(br)\s*\/?>/gi;
// Parses simple inline HTML tags (b/strong/em/i) into React elements while preserving surrounding text.
const parseInlineMarkup = (text) => {
    const parts = [];
    let lastIndex = 0;
    let match;
    while ((match = INLINE_TAG_REGEX.exec(text)) !== null) {
        const [fullMatch, pairedTagName, innerText, selfClosingTag] = match;
        if (match.index > lastIndex) {
            parts.push(text.slice(lastIndex, match.index));
        }
        if (selfClosingTag) {
            parts.push((0, react_1.createElement)("br", { key: `tag-${match.index}` }));
        }
        else if (pairedTagName) {
            const Tag = pairedTagName;
            parts.push((0, react_1.createElement)(Tag, { key: `tag-${match.index}` }, innerText));
        }
        lastIndex = match.index + fullMatch.length;
    }
    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }
    if (parts.length === 0) {
        return text;
    }
    return parts;
};
exports.parseInlineMarkup = parseInlineMarkup;
